import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as loginAction from "../../redux/action/LoginAction";
import { clearSession } from '../../services/Session';


export default function Logout(){
    const dispatch = useDispatch();

    const navigate = useNavigate()

    useEffect(() => {
        clearSession();
        dispatch(loginAction.resetLoginData());
        navigate("/login")

         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null
}

